<template lang="pug">
  .card
    p.slug {{slug}}
    p.title {{cardTitle}}
</template>
<script>
import MediaCard from './MediaCard';
export default {
  name: 'LibraryActionCard',
  components: {
    MediaCard
  },
  props:
  {
    slug: String,
    cardTitle: String,
    media: Object,
    title: String,
    callToAction: String
  }
}
</script>
<style lang="scss" scoped>
.card {
  padding: 1rem;
width: 100%;

  &:after {
    content: '';
    display: block;
  }

  .title {
    font-size: 1rem;
    margin-top: 0;
    margin: 0;
    height: auto;
  }

  .slug {
    color: #C5C5C5;
    font-size: 0.9rem;
    margin: 0 0 7px;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/general/LibraryActionCard.vue